// extracted by mini-css-extract-plugin
export var card = "_ak-0";
export var failedIcon = "_ak-4";
export var failedIconBadge = "_ak-3";
export var icon = "_ak-1";
export var successIcon = "_ak-2";